import { MESSAGING_ENABLED } from "../config/messagingEnabled";

let messagingModule;

if (MESSAGING_ENABLED) {
    messagingModule = require("./MessagesContext");
} else {
    messagingModule = require("./stub");
}

export const MessagesProvider = messagingModule.MessagesProvider;
export const useMessages = messagingModule.useMessages;

export const MessagesPageLazy = MESSAGING_ENABLED
    ? require("react").lazy(() => import("../pages/MessagesPage"))
    : null;
